import { Space } from 'antd';
import React, { useState } from 'react';
import { Button, ButtonGroup, Modal, Radio } from '@common/components';

type Props = {
  modalVisible: boolean;
  loading?: boolean;
  onConfirmModal: (override?: boolean) => void;
  onCancelModal: () => void;
};

export function WorkforceGroupSaveModal({
  modalVisible,
  loading,
  onConfirmModal,
  onCancelModal,
}: Props) {
  const [override, setOverride] = useState(false);

  return (
    <Modal
      title="Confirm Group Settings"
      visible={modalVisible}
      confirmLoading={loading}
      onCancel={onCancelModal}
      footer={
        <ButtonGroup align="right">
          <Button size="md" onClick={onCancelModal}>
            Cancel
          </Button>
          <Button
            kind="primary"
            size="md"
            onClick={() => onConfirmModal(override)}
            loading={loading}
          >
            Confirm
          </Button>
        </ButtonGroup>
      }
    >
      <p className="retract-change-request__content">
        Please select how you’d like to apply these new settings:
      </p>
      <Radio.Group
        onChange={(e) => setOverride(e.target.value)}
        value={override}
      >
        <Space direction="vertical">
          <Radio value={false}>
            <b>Save</b> - These settings will be the new default values for this
            Group and only Locations using default settings will be updated.
          </Radio>
          <Radio value={true}>
            <b>Save & Override</b> - These settings will be the new default
            values for this Group and all Locations will be updated. Custom
            settings for a specific location will be overridden.
          </Radio>
        </Space>
      </Radio.Group>
    </Modal>
  );
}
